import { useState } from 'react'
import { MapPin } from 'lucide-react'
import { useGeolocation } from '../hooks/useGeolocation'
import { useI18n } from '../i18n/useI18n'
import { hasAskedLocation, markLocationAsked } from '../lib/locationAsk'

/**
 * HOME で**初回 1 回だけ**、位置情報の使い道を説明して許可を聞くカード。
 *
 * 位置を要求していたのは「探す」と「旅程」だけだったので、そこを開くまでは HOME の
 * イベントの入口とお知らせが「現在地が分からないまま」の中身だった。かといって、入った
 * 瞬間にブラウザのダイアログを出すと断られやすく、断られると後から覆しにくい。
 * **何に使うかを先に読ませてから**、押した人にだけダイアログを出す。
 *
 * 初回の人はオンボーディングで聞くので、ここに来るのは**既にオンボーディングを
 * 終えている人**。どちらで聞いても同じフラグ (lib/locationAsk) を立て、二度は出さない。
 *
 * 出さない条件: もう聞いた / 既に許可・拒否が決まっている (status が idle でない)。
 */
export default function LocationAskCard() {
  const { t } = useI18n()
  const { status, requestLocation } = useGeolocation()
  const [done, setDone] = useState(() => hasAskedLocation())

  if (done || status !== 'idle') return null

  const allow = () => {
    markLocationAsked()
    setDone(true)
    requestLocation()
  }
  const later = () => {
    markLocationAsked()
    setDone(true)
  }

  return (
    <div className="animate-fade-in mx-4 mt-4 rounded-2xl border border-navy/10 bg-white p-4 shadow-card">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy/10 text-navy">
          <MapPin size={18} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-display text-sm font-semibold text-text-primary">
            {t('home.locationAskTitle')}
          </p>
          <p className="mt-1 font-body text-xs leading-relaxed text-text-secondary">
            {t('home.locationAskBody')}
          </p>
        </div>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={later}
          className="tap-effect h-10 rounded-xl border border-navy/20 bg-white font-body text-sm font-medium text-text-secondary"
        >
          {t('home.locationAskLater')}
        </button>
        <button
          type="button"
          onClick={allow}
          className="tap-effect h-10 rounded-xl bg-navy font-body text-sm font-semibold text-white"
        >
          {t('home.locationAskAllow')}
        </button>
      </div>
    </div>
  )
}
